<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.shipmentStatus === 'D' || row.shipmentStatus === 'R'
              ? 'warning'
              : row.shipmentStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_shipmentStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.shipmentCode },
                  query: { shipmentNo: row.shipmentNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.shipmentCode },
                  query: { shipmentNo: row.shipmentNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-dropdown trigger="click" @command="exportFile" v-if="allow('E')">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$l('INDEX.btn_export') || '导出'"
              placement="top"
            >
              <i class="el-icon-download tool-btn"></i>
            </el-tooltip>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="task in exportTasks"
                :key="task.templateGroup"
                :command="{ ...row, ...task }"
              >
                {{ task.exportName }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_upload_shipping_order') || '上传装船单'"
            placement="top"
            v-if="allow('U')"
          >
            <i
              class="el-icon-upload2 tool-btn"
              @click="uploadShippingOrder(row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_shipmentComplete') || '装船完成'"
            placement="top"
            v-if="allow('C')"
          >
            <i
              class="el-icon-circle-check tool-btn"
              @click="shipmentCompleted(row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="回退"
            placement="top"
            v-if="allow('D')"
          >
            <i class="el-icon-refresh-left tool-btn" @click="rollback(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>

    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        custCode: chooseTemplateOptions.custCode,
        endCustCode: chooseTemplateOptions.endCustCode,
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: { ...chooseTemplateOptions.exportParams },
        checkUrl: chooseTemplateOptions.exportCheckUrl,
      }"
      @confirmClose="confirmClose"
    />

    <ExportProductPacking
      :title="
        $l('INDEX.dialog_title_export_container_choose') ||
          '选择需要导出的装柜记录'
      "
      :visible.sync="exportInstallationOptions.visible"
      :shipmentCode="exportInstallationOptions.shipmentCode"
      @confirm="confirm"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import exportTasks from './export-tasks'
import EditLoading from '@/mixins/edit-loading'
import ChooseTemplate from '@/views/factory/transport/components/choose-template'
import ExportProductPacking from '@/views/factory/transport/waitProductionLoad/components/export-productpacking'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { ChooseTemplate, ExportProductPacking },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, defaul: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      exportTasks: exportTasks(this),
      chooseTemplateOptions: {
        visible: false,
        exportParams: {},
        custCode: '',
        endCustCode: '',
        templateGroup: '',
        exportCheckUrl: '',
      },
      exportInstallationOptions: {
        visible: false,
        shipmentCode: '',
      },
    }
  },
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'transport-wait-shipment-detail',
        params: { ...params, pageType },
        query,
      })
    },
    rollback(row) {
      const { shipmentCode, shipmentNo, shipmentStatus } = row
      this.$confirm(`确认要回退发运单【${shipmentNo}】吗？`, '确认信息', {
        type: 'warning',
      }).then(async () => {
        this.loadingOpen()
        const res = await this.$api.shipmentInfoBackApi({
          shipmentCode,
          shipmentStatus,
        })
        this.loadingClose()
        const { status, msg } = res
        if (status !== 200) {
          this.$message.error(msg)
          return
        }

        this.$message({
          showClose: true,
          message: res.msg,
          type: 'success',
        })
        this.$emit('reload')
      })
    },
    shipmentCompleted({ shipmentCode }) {
      this.$confirm(
        this.$l('tips_shipmentCompleted') || '是否要进行待装船完成操作？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .shipmentInfoShipmentCompletedApi({ shipmentCode })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
    uploadShippingOrder({ shipmentCode }) {
      console.log('uploadShippingOrder >>', shipmentCode)
    },
    exportFile({
      shipmentCode,
      custCode,
      endCustCode,
      templateGroup,
      exportCheckUrl,
    }) {
      switch (templateGroup) {
        case 'shipment-clrform':
        case 'shipment-siformat':
          this.exportInstallationOptions = {
            visible: true,
            shipmentCode: shipmentCode,
          }
          this.chooseTemplateOptions = {
            visible: false,
            custCode,
            endCustCode,
            templateGroup,
            exportCheckUrl,
          }
          return
        default:
          this.chooseTemplateOptions = {
            visible: true,
            exportParams: { shipmentCode },
            custCode,
            endCustCode,
            templateGroup,
            exportCheckUrl,
          }
      }
    },
    confirm(data) {
      this.chooseTemplateOptions = {
        ...this.chooseTemplateOptions,
        visible: true,
        exportParams: { ...data },
      }
    },
    confirmClose() {
      this.exportInstallationOptions.visible = false
    },
  },
}
</script>
